export default {
  methods: {
    fadeIn(el, display) {
      el.style.opacity = 0;
      el.style.display = display || 'block';

      (function fade() {
        let opacityVal = parseFloat(el.style.opacity);
        if (!((opacityVal += 0.1) > 1)) {
          el.style.opacity = opacityVal;
          requestAnimationFrame(fade);
        }
      })();
    }
  }
};
